import dJSON from 'dirty-json';

(() => {
  document.querySelectorAll('.module-team').forEach((item) => {
    const teamData = item.data;
    let arr = '';
    const data = dJSON.parse(teamData);

    Object.keys(data).forEach((key) => {
      const person = data[key];
      const img = person.image || 'https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-team-ph.png';
      const name = person.name || 'Anonymous';
      const title = person.title || 'Anonymous';

      const htmlString = /* html */ `
      <div class="team-slide">
        <img src="${img}" alt="">
        <h2>${name}</h2>
        <p>${title}</p>
      </div>
      `;

      arr += htmlString;
    });

    item.querySelector('.team-slider').innerHTML = arr;
    item.querySelector('script').remove();
  });
})();
